/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-require-imports */
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useCallback, useState} from 'react';
import {Image, Platform, ScrollView, View} from 'react-native';
import {connect} from 'react-redux';
import {defaultValues} from '../../../data/constants/login';
import {StackParams} from '../../../data/types/navigation';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import store from '../../../services/redux/store';
import {putFormData} from '../../../services/technique/api';
import {buttonsStyles} from '../../components/Button/boutonStyle';
import {CONFIDENTIALITE} from '../../components/Confidentialite';
import {HeaderScreen} from '../../components/Header/HeaderScreen';
import {styles} from '../../components/Header/HeaderScreen/styles';
import {formsStyles} from '../../components/Inputs/formStyles';
import {Loader} from '../../components/Loader';
import ConfirmationModal from '../../components/Modal/ConfirmationModal';
import {Form} from './FormWeb';

type NavigationProps = StackNavigationProp<StackParams, 'Login'>;

const dataws = {
  ...defaultValues,
};

export const FLogin = (props: any) => {
  const {navigate} = useNavigation<NavigationProps>();
  const [dataDto, setDataDto] = useState(dataws);
  const [postSucces, setPostSuccess] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const {signOutUser, route, authentificationUser, disconnectedUser} = props;

  const {data, params} = route?.params || {data: undefined, params: undefined};
  const {typeAssurance} = route && route.params ? route.params : '';
  const {age} = route && route.params ? route.params : '';
  const {montant} = route && route.params ? route.params : '';
  const {typeId} = route && route.params ? route.params : '';
  const {isSimulation} = route && route.params ? route.params : '';
  const [error, setError] = useState('');
  const [privacyPolicy, setPrivacyPolicy] = useState<boolean>(false);
  const [modalLoading, setModalLoading] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<Record<any, string>>({});

  useFocusEffect(
    useCallback(() => {
      if (Object.keys((store.getState() as any).user?.data ?? {})?.length > 0) {
        data === undefined ? navigate('Home') : navigate(data, {...params});
      }
    }, [(store.getState() as any).user]),
  );

  const handleCancel = () => {
    navigate('MotDePasseOublie');
  };

  const handleNavigation = () => {
    if (isSimulation) {
      if (data === 'SouscriptionAssuranceRCVPForm') {
        navigate('Inscription', {
          data: data,
          typeAssurance: typeAssurance,
          montant: montant,
          isSimulation: isSimulation,
          typeId,
        });
      } else if (data === 'SouscriptionAssuranceScolaireForm') {
        navigate('Inscription', {
          data: data,
          typeAssurance: typeAssurance,
          montant: montant,
          age: age,
          isSimulation: isSimulation,
          typeId,
        });
      } else {
        data === undefined
          ? navigate('Inscription')
          : navigate('Inscription', {data: data, params: {...params}, typeId});
      }
    } else {
      data === undefined
        ? navigate('Inscription')
        : navigate('Inscription', {data: data, params: {...params}, typeId});
    }
  };

  const processSave = (response: any) => {
    setIsLoading(true);
    setDataDto({...response});
    authentificationUser({...response}, (res: any) => {
      setIsLoading(false);
      if (res.error) {
        setError(res.error.message);
      } else if (res?.data?.utilisateur?.acceptedCondition) {
        setError('');
        if (isSimulation) {
          if (data === 'SouscriptionAssuranceRCVPForm') {
            navigate('SouscriptionAssuranceRCVPForm', {
              typeAssurance: typeAssurance,
              montant: montant,
              typeId,
            });
          } else if (data === 'SouscriptionAssuranceScolaireForm') {
            navigate('SouscriptionAssuranceScolaireForm', {
              typeAssurance: typeAssurance,
              montant: montant,
              age: age,
              typeId,
            });
          } else if (data === 'SouscriptionAssuranceRetraiteForm') {
            navigate('SouscriptionAssuranceRetraiteForm', {
              premierVersement: montant,
              dateNaissance: age,
            });
          } else {
            data === undefined ? navigate('Home') : navigate(data, {...params});
          }
        } else {
          if (data === 'SouscriptionAssuranceRetraiteForm') {
            navigate('SouscriptionAssuranceRetraiteForm', {
              premierVersement: '',
            });
          } else if (data === 'SouscriptionAssuranceScolaireForm') {
            navigate('SouscriptionAssuranceScolaireForm', {
              montant: '',
              typeId,
            });
          } else {
            console.log('ato am tsy simulation');

            data === undefined ? navigate('Home') : navigate(data, {...params});
          }
        }
      } else {
        setError('');
        setPrivacyPolicy(true);
        setCurrentUser(res.data.utilisateur);
      }
    });
  };

  const handleAcceptPrivacyPolicy = () => {
    setModalLoading(true);
    const formData = new FormData();
    formData.append('nom', currentUser.nom);
    formData.append('prenom', currentUser.prenom);
    formData.append('telephone', currentUser.telephone);
    formData.append('email', currentUser.email);
    formData.append('ville', currentUser.ville);
    formData.append('adresse', currentUser.adresse);
    formData.append('id', currentUser.id);
    formData.append('acceptedCondition', 'true');

    putFormData('auth/utilisateur/profil', formData).then((res: any) => {
      if (res.status === 200) {
        setModalLoading(false);
        setPrivacyPolicy(false);
      }
    });
    if (isSimulation) {
      if (data === 'SouscriptionAssuranceRCVPForm') {
        navigate('SouscriptionAssuranceRCVPForm', {
          typeAssurance: typeAssurance,
          montant: montant,
          typeId,
        });
      } else if (data === 'SouscriptionAssuranceScolaireForm') {
        navigate('SouscriptionAssuranceScolaireForm', {
          typeAssurance: typeAssurance,
          montant: montant,
          age: age,
          typeId,
        });
      } else if (data === 'SouscriptionAssuranceRetraiteForm') {
        navigate('SouscriptionAssuranceRetraiteForm', {
          premierVersement: montant,
          dateNaissance: age,
        });
      } else if (data === 'Notification') {
        navigate('Notification', {
          initialize: true,
        });
      } else {
        data === undefined ? navigate('Home') : navigate(data);
      }
    } else {
      if (data === 'SouscriptionAssuranceRetraiteForm') {
        navigate('SouscriptionAssuranceRetraiteForm', {
          premierVersement: '',
        });
      } else if (data === 'SouscriptionAssuranceScolaireForm') {
        navigate('SouscriptionAssuranceScolaireForm', {montant: '', typeId});
      } else if (data === 'Notification') {
        navigate('Notification', {
          initialize: true,
        });
      } else {
        data === undefined ? navigate('Home') : navigate(data);
      }
    }
  };

  const handleLogout = () => {
    disconnectedUser({}, () => {});
    signOutUser({}, () => {
      navigate('Home');
    });
  };
  const exit = () => {
    handleLogout();
  };

  const handleSubmit = (dataws: any) => {
    setDataDto(dataws);
    processSave(dataws);
  };

  const handleInscription = () => {
    handleNavigation();
  };

  return (
    <View style={[Platform.OS === 'web' ? null : formsStyles.formLogInscr]}>
      {Platform.OS !== 'web' ? (
        <Image
          style={formsStyles.FondMobile}
          source={require('../../../ressources/images/fondLogin.png')}
        />
      ) : null}
      {privacyPolicy ? (
        <ConfirmationModal
          title="Confidentialité"
          content={CONFIDENTIALITE}
          btn1="Accepter"
          btn2="Fermer"
          handleBtn1={handleAcceptPrivacyPolicy}
          handleBtn2={exit}
          loader={modalLoading}
        />
      ) : null}
      <HeaderScreen
        title="Connexion"
        type="home"
        noBreadcrumb={false}
        noIcon={true}
      />
      <ScrollView>
        <View style={formsStyles.webformContain}>
          <View
            style={
              Platform.OS === 'web'
                ? [formsStyles.formContain, formsStyles.formWebs]
                : [formsStyles.formContain, formsStyles.bgTrans]
            }>
            {Platform.OS !== 'web' && (
              <View style={buttonsStyles.displayCenterImageLogin}>
                <Image
                  style={styles.ImageLogin}
                  source={require('../../../ressources/images/LogoAro.png')}
                />
              </View>
            )}

            {IsLoading && <Loader />}
            {/** Form content */}
            {!postSucces && !IsLoading && (
              <Form
                data={dataDto}
                insciptionAction={handleInscription}
                listAgence={[]}
                error={error}
                onCancelForm={handleCancel}
                onSubmitForm={handleSubmit}
              />
            )}
          </View>
        </View>
      </ScrollView>
    </View>
  );
};
export const Login: any = connect(mapStateToProps, mapDispatchToProps)(FLogin);
